import axios from 'axios';

const axiosInstance = axios.create({
	headers: {
		'x-territory-key': process.env.REACT_APP_TERRITORY_KEY,
	},
	baseURL: process.env.REACT_APP_LS_API_URL,
});

axiosInstance.interceptors.response.use((res) => res.data);

export const createProspect = async (data) => {
	return axiosInstance.post('/internal', data, {
		baseURL: process.env.REACT_APP_PROSPECT_API_URL,
	});
};

export const getWebsiteTemplate = async (code) => {
	return axiosInstance.get(`${process.env.REACT_APP_CONTRACT_API_URL}companies/fetch/website/details?companyCode=${code}`);
};

export const getIdamToken = async (prospectId) => {
	return axiosInstance.get(`${process.env.REACT_APP_IDAM_TOKEN_API_URL}/token?prospectId=${prospectId}`);
}
